import { PaymentProvidersWorkspace } from '@workspace/silk-ui';
import { usePaymentProvidersController } from './usePaymentProvidersController';

export default function PaymentProvidersPage() {
  const viewModel = usePaymentProvidersController();
  return <PaymentProvidersWorkspace {...viewModel} />;
}
